export type IUserToastMsg = (
  type: 'error' | 'success' | 'info' | 'warning',
  title: string,
  message?: string
) => void;

export function userToastMsg(
  type: 'error' | 'success' | 'info' | 'warning',
  title: string,
  message?: string
) {
  if (type === 'error') {
    window.toastr.error(message, title);
  } else if (type === 'success') {
    window.toastr.success(message, title);
  } else if (type === 'info') {
    window.toastr.info(message, title);
  } else if (type === 'warning') {
    window.toastr.warning(message, title);
  }
}
